export default __webpack_public_path__ + "a1607b306b73deaceb6eb17d1cb34c62.png";